module.exports = __webpack_public_path__ + "static/media/une_logo.149a68d3.svg";